var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      width: "700",
      scrollable: "",
      title: _vm.iSEdited
        ? _vm.$t("label_essweb_ClaimType_form_dilog_editApprovalFlowTitle")
        : _vm.$t("label_essweb_ClaimType_form_dilog_viewApprovalFlowTitle"),
      dialog: _vm.show,
    },
    on: { close: _vm.closeDialog },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "v-form",
              { ref: "form", attrs: { "lazy-validation": "" } },
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("normalInputTextFiled", {
                          attrs: {
                            type: "number",
                            filled: _vm.iSEdited,
                            readonly: !_vm.iSEdited,
                            maxlength: "10",
                            label: _vm.$t(
                              "label_essweb_ClaimType_form_dilog_claimAmountLabel"
                            ),
                            rules: _vm.$GetRules(
                              ["_Number_negative", "_Length_Rules"],
                              [null, 10]
                            ),
                            placeholder: _vm.$t(
                              "label_essweb_ClaimType_form_dilog_claimAmountLabel"
                            ),
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "prepend-inner",
                              fn: function () {
                                return [
                                  _c("span", { staticClass: "mt-1" }, [
                                    _vm._v("≥"),
                                  ]),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.approvalFlowData.amount,
                            callback: function ($$v) {
                              _vm.$set(_vm.approvalFlowData, "amount", $$v)
                            },
                            expression: "approvalFlowData.amount",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c(
                          "v-sheet",
                          { staticClass: "mrc_text_require text--secondary" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "label_essweb_ClaimType_form_dilog_approvalTemplateLabel"
                                )
                              )
                            ),
                          ]
                        ),
                        _c("v-autocomplete", {
                          attrs: {
                            items: _vm.approvalTemplates,
                            "item-text": "flow_template_name",
                            "item-value": "uuid",
                            filled: _vm.iSEdited,
                            readonly: !_vm.iSEdited,
                            "append-icon": _vm.iSEdited
                              ? "arrow_drop_down"
                              : "",
                            "single-line": "",
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            placeholder: _vm.$t(
                              "label_essweb_ClaimType_form_dilog_approvalTemplateLabel"
                            ),
                            dense: "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "no-data",
                              fn: function () {
                                return [_c("noContent")]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value:
                              _vm.approvalFlowData.approval_flow_template_uuid,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.approvalFlowData,
                                "approval_flow_template_uuid",
                                $$v
                              )
                            },
                            expression:
                              "approvalFlowData.approval_flow_template_uuid",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _vm.iSEdited
              ? _c("CardActions", {
                  attrs: { saveBtn: "", cancelBtn: "" },
                  on: { save: _vm.onSave, cancel: _vm.closeDialog },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }